var map = {
	"./android/DeviceSetup": 1789,
	"./androidtv/DeviceSetup": 1790,
	"./arris/DeviceSetup": 1791,
	"./hisense/DeviceSetup": 1792,
	"./lg/DeviceSetup": 1793,
	"./nagra/DeviceSetup": 1795,
	"./netrange/DeviceSetup": 1796,
	"./opera/DeviceSetup": 1797,
	"./polaroid/DeviceSetup": 1798,
	"./ps4/DeviceSetup": 1799,
	"./samsung/DeviceSetup": 1800,
	"./seirobotics/DeviceSetup": 1801,
	"./sony/DeviceSetup": 1802,
	"./stbcoship/DeviceSetup": 1803,
	"./stbcoship9108/DeviceSetup": 1804,
	"./stbhuawei/DeviceSetup": 1805,
	"./stbkaon/DeviceSetup": 1806,
	"./tizen/DeviceSetup": 1807,
	"./web0s/DeviceSetup": 1808,
	"./workstation/DeviceSetup": 1810,
	"./workstationChafari/DeviceSetup": 1811,
	"./zeasn/DeviceSetup": 1812,
	"./zte/DeviceSetup": 1813
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1788;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/DeviceSetup$
// module id = 1788
// module chunks = 0